.entry:not(:last-child) {
  border-bottom: 1px solid var(--mantine-color-gray-1);
}

.entry {
  cursor: pointer;
}

.entry:hover {
  background-color: var(--mantine-color-gray-0);
}
